gdk = {};
(function () {
  function GDK() {
    var self = this;
    self.readyCb = undefined;
    self.documentReady = false;
    self.serverParser = undefined;
    self.bpl = 0;
    self.autoplay = {};
    self.currency = 'GBP';
    self.currentLanguage = 'en';
    self.availableLanguages = ['en'];
    self.stakeFactor = 1;
    self.translationKeysUsed = {};
    self.minGameTime = 0;
    self.hasRequestedEndGame = false;
    self.hasMinGameTimeElapsed = false;
    self.configValues = {};
    self.endGameCallback = undefined;
    self.path = window.location.pathname.substring(0, window.location.pathname.lastIndexOf('/')) + '/';
    self.initPlatformScreenData();

    self.initAutoplay();
    messageBus.subscribe('spinner:GameConfigEvent', function (task) {
      self.bpl = task.data.slotConfig !== undefined ? task.data.slotConfig.defaultAmountPerLine : 0;
      self.numWinlines = task.data.slotConfig !== undefined ? task.data.slotConfig.defaultNumLines : 0;

      if (task.data.autoplay) {
        self.autoplay.fields.numberOfRounds.values =
          task.data.autoplay.numberOfRounds?.values ?? self.autoplay.fields.numberOfRounds.values;

        self.autoplay.fields.numberOfRounds.defaultIndex =
          task.data.autoplay.numberOfRounds?.defaultIndex ?? self.autoplay.fields.numberOfRounds.defaultIndex;

        self.autoplay.fields.lossLimit.values =
          task.data.autoplay.lossLimit?.values ?? self.autoplay.fields.lossLimit.values;

        self.autoplay.fields.lossLimit.defaultIndex =
          task.data.autoplay.lossLimit?.defaultIndex ?? self.autoplay.fields.lossLimit.defaultIndex;

        self.autoplay.fields.singleWinLimit.values =
          task.data.autoplay.singleWinLimit?.values ?? self.autoplay.fields.singleWinLimit.values;

        self.autoplay.fields.singleWinLimit.defaultIndex =
          task.data.autoplay.singleWinLimit?.defaultIndex ?? self.autoplay.fields.singleWinLimit.defaultIndex;

        if (task.data.autoplay.maxNumRounds) {
          self.autoplay.fields.numberOfRounds.values = self.autoplay.fields.numberOfRounds.values.filter(
            (num) => num <= task.data.autoplay.maxNumRounds
          );
        }
      }
    });

    messageBus.subscribe('common:TotalGameWinnings', function (task) {
      if (self.autoplay.isEnabled() && self.autoplay.isActive()) {
        const winnings = task.data.totalGameWinnings;

        self.autoplay.session.lastwin = winnings;
        self.autoplay.session.losscount += self.autoplay.session.lastwin;
      }
    });

    messageBus.subscribe('common:BalanceEvent', function (task) {
      self.balance = task.data.balance;
    });

    messageBus.subscribe('common:RecoverGameDead', function () {
      gdk.serverParser.getNextGameOutcome(function () {});
    });

    $(document).ready(function () {
      self.documentReady = true;
      self.checkCanInitServer();
    });
  }

  GDK.prototype.setLanguageData = function (data) {
    this.languageData = data;
  };

  GDK.prototype.checkCanInitServer = function () {
    let self = this;
    if (!self.documentReady || !self.readyCb) return;

    self.serverParser.initServer(function () {
      if (!gdk.deviceInfo) {
        self.initDeviceInfo();
      }

      systemData.engineSupplier = self.getEngineSupplier();

      if (systemData.engineSupplier !== 'bragg') {
        if (self.serverParser.loadLanguageFiles) {
          self.serverParser.loadLanguageFiles(function (ld) {
            self.languageData = ld;
            self.configTranslations();
            self.readyCb();
          });
        } else {
          self.loadLanguageFiles(function () {
            self.readyCb();
          });
        }
      } else {
        self.readyCb();
      }
    });
  };

  GDK.prototype.addConfigValue = function (name, value) {
    this.configValues[name] = value;
  };

  GDK.prototype.getConfigValue = function (name) {
    return this.configValues[name];
  };

  GDK.prototype.getAllConfigValues = function () {
    return this.configValues;
  };

  GDK.prototype.getRegulatedMarket = function () {
    return this.serverParser.getRegulatedMarket();
  };

  GDK.prototype.getCurrentLanguage = function () {
    return this.currentLanguage;
  };

  // should be used for gui animations etc. Not game logic or anything that may change during recovery
  GDK.prototype.rngGeneratorNonCritical = function (callback, rngRequests) {
    let range = rngRequests[0].excHi - rngRequests[0].incLow;
    callback(Math.floor(Math.random() * range) + rngRequests[0].incLow);
  };

  GDK.prototype.setMinGameTime = function (minTime) {
    this.minGameTime = minTime;
  };

  GDK.prototype.setAvailableLanguages = function (available, defaultLanguage) {
    this.availableLanguages = available;
    this.setCurrentLanguage(defaultLanguage);
  };

  GDK.prototype.getAvailableLanguages = function () {
    return this.availableLanguages;
  };

  GDK.prototype.ammendResourceName = function (resourceName) {
    if (this.serverParser.ammendResourceName) {
      return this.serverParser.ammendResourceName(resourceName);
    }
    return resourceName;
  };

  GDK.prototype.translateTextOLD = function (phraseId, strParams) {
    var res = phraseId;

    if (this.translationKeysUsed[phraseId] !== undefined) {
      this.translationKeysUsed[phraseId] = true;
    }

    if (this.languageData[this.currentLanguage][phraseId] !== undefined) {
      res = this.languageData[this.currentLanguage][phraseId];
      for (var i = 0; i < strParams.length; ++i) {
        var strToFind = '%' + (i + 1) + '%';
        while (res.indexOf(strToFind) !== -1) {
          res = res.replace(strToFind, strParams[i]);
        }
      }
    }
    return res;
  };

  GDK.prototype.translateText = function (phraseId, strParams) {
    const phraseIds = Array.isArray(phraseId) ? phraseId : [phraseId];

    let res = '';

    for (let p = 0; p < phraseIds.length; p++) {
      if (this.translationKeysUsed[phraseIds[p]] !== undefined) {
        this.translationKeysUsed[phraseIds[p]] = true;
      }

      if (this.languageData[this.currentLanguage][phraseIds[p]] !== undefined) {
        res += this.languageData[this.currentLanguage][phraseIds[p]];
        for (let i = 0; i < strParams.length; ++i) {
          const strToFind = '%' + (i + 1) + '%';
          while (res.indexOf(strToFind) !== -1) {
            res = res.replace(strToFind, strParams[i]);
          }
        }
      } else {
        res += phraseIds[p];
      }
    }

    return res;
  };

  GDK.prototype.setCurrentLanguage = function (newLanguage) {
    if (this.currentLanguage !== newLanguage) {
      if (this.availableLanguages.indexOf(newLanguage) !== -1) {
        this.currentLanguage = newLanguage;
        messageBus.post('languageChanged', newLanguage);
      } else {
        // fatal error
      }
    }
  };

  GDK.prototype.initPlatformScreenData = function () {
    this._screenData = {
      isSet: false,
      screenData: {
        borderTop: 0,
        borderBottom: 0,
        borderLeft: 0,
        borderRight: 0,
      },
    };
  };

  GDK.prototype.clearPlatformScreenData = function () {
    this.initPlatformScreenData();
    Reflex.updateViewport();
  };
  GDK.prototype.setPlatformScreenData = function (data) {
    this._screenData.isSet = true;
    this._screenData.screenData = data;
    Reflex.updateViewport();
  };
  GDK.prototype.getPlatformScreenData = function () {
    return this._screenData;
  };

  GDK.prototype.validateLanguageFiles = function () {
    var languageCodeKeys = Object.keys(this.languageData);

    // There must be at least one language
    if (languageCodeKeys.length === 0) {
      console.error('No languages defined in language file');
      return;
    }

    // We need to check if each of the key names in the root language matches each other language
    var rootLanguageTagKeys = Object.keys(this.languageData[languageCodeKeys[0]]);

    for (var i = 1; i < languageCodeKeys.length; i++) {
      var languageTagKeys = Object.keys(this.languageData[languageCodeKeys[i]]);
      var keysMissing = false;

      // Work out which keys from the root language are missing from the current language
      for (var j = 0; j < rootLanguageTagKeys.length; j++) {
        if (languageTagKeys.indexOf(rootLanguageTagKeys[j]) === -1) {
          console.error(
            ' - ' + rootLanguageTagKeys[j] + ' is in ' + languageCodeKeys[0] + ' but not in ' + languageCodeKeys[i]
          );
          keysMissing = true;
        }
      }

      // Work out which keys from the current language are not in the root language
      for (var j = 0; j < languageTagKeys.length; j++) {
        if (rootLanguageTagKeys.indexOf(languageTagKeys[j]) === -1) {
          console.error(
            ' - ' + languageTagKeys[j] + ' is in ' + languageCodeKeys[i] + ' but not in ' + languageCodeKeys[0]
          );
          keysMissing = true;
        }
      }
    }

    // Check for empty strings
    for (var i = 0; i < languageCodeKeys.length; i++) {
      var languageTagKeys = Object.keys(this.languageData[languageCodeKeys[i]]);
      for (var j = 0; j < languageTagKeys.length; j++) {
        if (this.languageData[languageCodeKeys[i]][languageTagKeys[j]] === '') {
          console.error(
            'Empty tag in language file (language: "' + languageCodeKeys[i] + '", tag: "' + languageTagKeys[j] + '")'
          );
        }
      }
    }

    // Track which translation phrases we have used
    for (var i = 0; i < languageTagKeys.length; i++) {
      this.translationKeysUsed[languageTagKeys[i]] = false;
    }
  };

  GDK.prototype.configTranslations = function () {
    this.validateLanguageFiles();
    this.availableLanguages = [];

    for (var prop in this.languageData) {
      if (this.languageData.hasOwnProperty(prop)) {
        this.availableLanguages.push(prop);
      }
    }

    // If we have already had a message to tell us the language, use that, else use first language
    var languageIndex = Math.max(0, Object.keys(this.languageData).indexOf(this.currentLanguage));
    this.setCurrentLanguage(Object.keys(this.languageData)[languageIndex]);
    messageBus.post('languageChanged', this.currentLanguage);
  };

  GDK.prototype.loadLanguageFiles = function (cb) {
    const self = this;
    const fileName = self.isSocial() === true ? 'config/langSocial.json' : 'config/lang.json';
    const webrequest = self.requestAsset(fileName, function () {
      if (webrequest.status === 200) {
        //parse classProperties
        self.languageData = JSON.parse(webrequest.responseText);
        self.configTranslations();
        cb();
      } else if (webrequest.status === 404) {
        console.error(`${fileName} not found`);
      }
    });
    webrequest.send(null);
  };

  GDK.prototype.saveLanguageDataToFile = function () {
    if (gdk.isDevelopmentBuild() && this.serverParser.saveLanguageDataToFile)
      this.serverParser.saveLanguageDataToFile();
  };

  GDK.prototype.checkUnusuedResources = function () {
    console.log('The following lauguage tags have not yet been used');

    var translationKeys = Object.keys(this.translationKeysUsed);
    for (var i = 0; i < translationKeys.length; i++) {
      if (!this.translationKeysUsed[translationKeys[i]]) {
        console.log('- ' + translationKeys[i]);
      }
    }
  };

  GDK.prototype.getBalance = function () {
    return this.balance;
  };

  GDK.prototype.setCurrency = function (curr) {
    if (curr) this.currency = curr;
  };
  GDK.prototype.getCurrency = function () {
    return this.currency;
  };

  GDK.prototype.initDeviceInfo = function () {
    this.deviceInfo = this.serverParser.getDeviceInfo();
  };

  GDK.prototype.setStakeMultiplier = function (multiplier) {
    this.stakeFactor = multiplier;
  };
  GDK.prototype.canFullScreen = function () {
    return systemData.canFullScreen && this.serverParser.canFullScreen();
  };

  GDK.prototype.removeFloatingPoint = function (amount) {
    return this.serverParser.removeFloatingPoint(amount);
  };

  GDK.prototype.getPlatformAllowsAutoplay = function () {
    return this.serverParser.isAutoplayAllowed();
  };

  GDK.prototype.getPlatformAllowsBuyBonus = function () {
    return this.serverParser.isBuyBonusAllowed();
  };

  GDK.prototype.checkBuyBonusStakes = function (id) {
    return this.serverParser.checkBuyBonusStakes(id);
  };

  GDK.prototype.checkUpstakeStakes = function (id) {
    return this.serverParser.checkUpstakeStakes(id);
  };

  GDK.prototype.getPlatformAllowsGamble = function () {
    if (this.serverParser.isGambleAllowed) return this.serverParser.isGambleAllowed();
    return false;
  };

  GDK.prototype.getPlatformAllowsUpstake = function () {
    if (this.serverParser.isUpstakeAllowed) return this.serverParser.isUpstakeAllowed();
    return false;
  };

  GDK.prototype.getPlatformAllowsGameRules = function () {
    if (this.serverParser.isGameRulesAllowed) return this.serverParser.isGameRulesAllowed();
    return true;
  };

  GDK.prototype.getPlatformAllowsSplashScreen = function () {
    return this.serverParser.getAllowSplashScreen();
  };

  GDK.prototype.getPrizeTable = function () {
    return this.serverParser.getPrizeTable();
  };

  GDK.prototype.initAutoplay = function () {
    var self = this;

    this.autoplay.active = false;
    this.autoplay.session = {};

    this.autoplay.resetSession = function () {
      this.session.remaining = 0;
      this.session.losscount = 0;
      this.session.lastwin = 0;
    };

    this.autoplay.stop = function () {
      if (this.active && gdk.serverParser.cancelAutoplay) {
        gdk.serverParser.cancelAutoplay();
      }
      this.active = false;
      this.resetSession();
    };

    this.autoplay.start = function (stake) {
      this.active = true;
      let betAmount = 0;
      if (systemData.engineSupplier === 'bragg') {
        betAmount = stake * 100;
        this.session.lastwin = 0;
      } else {
        betAmount = self.bpl * self.numWinlines * self.stakeFactor;
      }
      this.session.remaining = this.fields.numberOfRounds.currentValue;
      this.session.losscount = this.fields.lossLimit.currentValue * betAmount;
      self.serverParser.chosenAutoplayData(
        this.session.remaining,
        this.session.losscount,
        this.fields.singleWinLimit.currentValue * betAmount,
        betAmount
      );
    };

    this.autoplay.canStart = function () {
      return (
        self.serverParser.canAutoplayContinue() &&
        this.fields.numberOfRounds.currentValue * self.bpl * self.numWinlines <= self.balance
      );
    };

    this.autoplay.roundsRemaining = function () {
      return this.session.remaining;
    };

    this.autoplay.isActive = function () {
      return this.active;
    };

    this.autoplay.isEnabled = function () {
      return true;
    };

    this.autoplay.canContinue = function () {
      if (!self.serverParser.canAutoplayContinue()) {
        return {
          res: false,
          reason: 'EXPIRED',
        };
      }
      var winLimitSet = this.fields.singleWinLimit.currentValue !== -1;
      var lossLimitSet = this.fields.lossLimit.currentValue !== -1;
      let stake = self.bpl * self.numWinlines * self.stakeFactor;
      var spinCost = !self.serverParser.isPromotionActive() || self.serverParser.isPromotionChargeable() ? stake : 0;

      if (this.session.remaining === 0) {
        //A value less than 0 is interpreted as infinite autoplays
        return {
          res: false,
          reason: 'EXPIRED',
        };
      } else if (lossLimitSet && this.session.losscount - spinCost < 0) {
        return {
          res: false,
          reason: 'LOSS_LIMIT',
        };
      } else if (winLimitSet && this.session.lastwin >= this.fields.singleWinLimit.currentValue * stake) {
        return {
          res: false,
          reason: 'WIN_LIMIT',
        };
      } else if (!self.allowSpinIfNotEnoughCredit() && self.balance < spinCost) {
        return {
          res: false,
          reason: 'INSUFFICIENT_CREDIT',
        };
      }

      return {
        res: true,
      };
    };

    this.autoplay.reset = function () {
      this.fields.numberOfRounds.currentValue =
        this.fields.numberOfRounds.values[this.fields.numberOfRounds.defaultIndex];
      this.fields.lossLimit.currentValue = this.fields.lossLimit.values[this.fields.lossLimit.defaultIndex];
      this.fields.singleWinLimit.currentValue =
        this.fields.singleWinLimit.values[this.fields.singleWinLimit.defaultIndex];
      this.resetSession();
    };

    this.autoplay.fields = {};

    this.autoplay.fields.numberOfRounds = {};
    this.autoplay.fields.numberOfRounds.id = 'numberOfRounds';
    this.autoplay.fields.numberOfRounds.defaultIndex = 0;
    this.autoplay.fields.numberOfRounds.values = [10, 20, 50, 100];

    this.autoplay.fields.lossLimit = {};
    this.autoplay.fields.lossLimit.id = 'lossLimit';
    this.autoplay.fields.lossLimit.defaultIndex = 1;
    this.autoplay.fields.lossLimit.values = [5, 10, 30, 40, 50];

    this.autoplay.fields.singleWinLimit = {};
    this.autoplay.fields.singleWinLimit.id = 'singleWinLimit';
    this.autoplay.fields.singleWinLimit.defaultIndex = 0;
    this.autoplay.fields.singleWinLimit.values = [-1, 10, 20, 50, 100];

    this.autoplay.reset();

    this.autoplay.setField = function (fieldId, value) {
      this.fields[fieldId].currentValue = value;
    };

    this.autoplay.getFields = function () {
      return this.fields;
    };

    this.autoplay.newGame = function (stake) {
      if (this.session.remaining > 0) {
        //A value less than 0 is interpreted as infinite autoplays
        this.session.remaining--;
      }

      //If we are in a non-charging promotion then the loss count should not be changed
      if (!self.serverParser.isPromotionActive() || self.serverParser.isPromotionChargeable()) {
        this.session.losscount -= stake * gdk.stakeFactor;
      }
    };
  };

  GDK.prototype.setCurrentBPL = function (bpl) {
    if (systemData.engineSupplier === 'bragg') {
      this.bpl = 1000;
      this.serverParser.setBPL(1000);
    } else {
      this.bpl = bpl;
      this.serverParser.setBPL(this.bpl);
    }
  };

  GDK.prototype.playerChangedStake = function (stake, cb) {
    this.serverParser.playerChangedStake(stake, cb);
  };

  GDK.prototype.formatCurrency = function (value, currencySymbols = true) {
    if (value === undefined || isNaN(value)) {
      value = 0;
    }

    return this.serverParser.formatCurrency(value, this.currency, currencySymbols);
  };

  GDK.prototype.getAutoplayObject = function () {
    return this.autoplay;
  };

  GDK.prototype.showAutoplay = function () {
    if (systemData.engineSupplier == 'Playzido') {
      this.serverParser.showAutoplay();
      messageBus.post('game:modal', {
        reason: 'autoplay',
        data: 'gdk - showAutoplay',
      });
    } else {
      resourceManager.getController('autoplayController').showPopup();
    }
  };

  GDK.prototype.cancelAutoplay = function () {
    if (systemData.engineSupplier == 'Playzido') {
      this.serverParser.cancelAutoplay();
    } else {
      resourceManager.getController('autoplayController').cancel();
    }
  };

  GDK.prototype.onReady = function (cb) {
    this.readyCb = cb;
    this.checkCanInitServer();
  };

  GDK.prototype.getServerParser = function () {
    return this.serverParser;
  };
  GDK.prototype.setServerParser = function (parser) {
    this.serverParser = parser;
  };
  GDK.prototype.addMessageToQueue = function (message) {
    gdk.serverParser.addMessageToQueue(message);
  };
  GDK.prototype.setAllowCheats = function () {
    this.serverParser.setAllowCheats();
  };

  GDK.prototype.helpPageShowingPaytable = function (showing) {
    this.serverParser.helpPageShowingPaytable(showing);
  };

  GDK.prototype.helpPageVisible = function (visible) {
    this.serverParser.helpPageVisible(visible);
  };

  GDK.prototype.stakePopupVisible = function (visible) {
    this.serverParser.stakePopupVisible(visible);
  };

  GDK.prototype.finishedLoading = function () {
    this.serverParser.gameLoaded();
    messageBus.post('common:FullyLoaded');
  };

  GDK.prototype.peekNextMessage = function () {
    return this.serverParser.peekNextMessage();
  };

  GDK.prototype.isProductionBuild = function () {
    return this.serverParser.isProductionBuild();
  };

  GDK.prototype.hasReplayForce = function () {
    return gdk.hasForceOptions() && this.serverParser.hasReplayForce();
  };

  GDK.prototype.isPromotionActive = function () {
    if (this.serverParser.isPromotionActive) {
      return this.serverParser.isPromotionActive();
    }

    return false;
  };

  GDK.prototype.isPromotionChargeable = function () {
    if (this.serverParser.isPromotionChargeable) {
      return this.serverParser.isPromotionChargeable();
    }

    return true;
  };

  GDK.prototype.getEngineSupplier = function () {
    return this.serverParser.getEngineSupplier();
  };

  GDK.prototype.getOperatorName = function () {
    if (this.serverParser.getOperatorName) {
      return this.serverParser.getOperatorName();
    }
    return '';
  };

  GDK.prototype.getSupplierForceName = function () {
    return 'gati';
  };

  GDK.prototype.getEngineVersion = function () {
    return this.serverParser.getEngineVersion();
  };

  GDK.prototype.handleServerMessage = function (message) {
    var type = message.type;
    var self = this;
    var deadHandler = function () {
      if (self.serverParser.allowDebugLogging()) {
        console.log('GDK: Received task dead ' + type);
      }
      messageBus.unsubscribe(type + 'Dead', deadHandler);
      self.serverParser.messageHandled();
    };
    messageBus.subscribe(type + 'Dead', deadHandler);
    if (this.serverParser.allowDebugLogging()) {
      console.log('GDK: Starting task ' + type);
    }

    messageBus.task(type, message);
  };

  GDK.prototype.getPlatformLoadingData = function () {
    return this.serverParser.getPlatformLoadingData();
  };

  GDK.prototype.endGameIfReady = function () {
    if (this.hasMinGameTimeElapsed && this.hasRequestedEndGame) {
      this.hasMinGameTimeElapsed = false;
      this.hasRequestedEndGame = false;
      var self = this;
      function serverCb() {
        self.endGameCallback();
        self.endGameCallback = undefined;
        messageBus.post('common:ReadyToStart');
      }
      this.serverParser.endGame(serverCb);
    }
  };

  GDK.prototype.minGameTimeExpired = function () {
    this.hasMinGameTimeElapsed = true;
    Reflex.removeFromUpdate(this.updateBinder);
    this.endGameIfReady();
  };

  GDK.prototype.gameTimerUpdater = function (delta) {
    this.gameTimeLeft -= delta;
    if (this.gameTimeLeft <= 0) {
      this.gameTimeLeft = 0;
      this.minGameTimeExpired();
    }
  };

  GDK.prototype.startMinGameTimer = function () {
    this.hasMinGameTimeElapsed = false;
    this.gameTimeLeft = this.minGameTime * 1000;
    this.updateBinder = this.gameTimerUpdater.bind(this);
    Reflex.addToUpdate(this.updateBinder);
  };

  GDK.prototype.startGame = function (stakeData, cb) {
    resourceManager.getController('inputOverlord').disableAll();
    var callback = cb;

    if (this.updateBinder !== undefined) {
      Reflex.removeFromUpdate(this.updateBinder);
    }

    this.hasMinGameTimeElapsed = false;
    this.hasRequestedEndGame = false;
    this.endGameCallback = undefined;

    var self = this;
    if (stakeData.stake) {
      if (!stakeData.bpl) {
        stakeData.bpl = stakeData.stake / stakeData.numWinlines;
      }
      self.bpl = stakeData.bpl;
    }

    if (self.autoplay.isEnabled() && self.autoplay.isActive()) {
      self.autoplay.newGame(stakeData.stake);
    }

    var serverCb = function () {
      callback();
    };
    self.startMinGameTimer();
    self.serverParser.startGame(stakeData, serverCb);
    messageBus.post('common:GameCommitted');
  };

  GDK.prototype.getNextGameOutcome = function (cb) {
    //this.autoplay.session.lastwin = 0;
    this.serverParser.getNextGameOutcome(cb);
  };

  GDK.prototype.allowSpinIfNotEnoughCredit = function () {
    return this.serverParser.allowSpinIfNotEnoughCredit();
  };

  GDK.prototype.endGame = function (cb) {
    this.endGameCallback = cb;
    this.hasRequestedEndGame = true;
    this.endGameIfReady();
  };

  GDK.prototype.generateRecoveryData = function () {
    //if (this.serverParser.generateRecoveryData){
    //	var data = this.serverParser.generateRecoveryData();
    //}
  };

  GDK.prototype.isGameRecovering = function () {
    if (this.serverParser.isGameRecovering) {
      return this.serverParser.isGameRecovering();
    }
    return false;
  };
  GDK.prototype.saveClientState = function (data, cb) {
    return this.serverParser.saveClientState(data, cb);
  };
  GDK.prototype.getSavedClientState = function () {
    if (this.serverParser.getSavedClientState) {
      return this.serverParser.getSavedClientState();
    }
    return {};
  };
  GDK.prototype.updateAndSaveClientState = function (propertyName, propertyValue, cb) {
    if (this.serverParser.updateAndSaveClientState) {
      this.serverParser.updateAndSaveClientState(propertyName, propertyValue, cb);
    } else {
      cb();
    }
  };
  GDK.prototype.savePlayerPreferences = function (data, cb) {
    if (this.serverParser.savePlayerPreferences) {
      this.serverParser.savePlayerPreferences(data, cb);
    } else {
      cb();
    }
  };

  GDK.prototype.hasForceOptions = function () {
    return this.serverParser.hasForceOptions();
  };

  GDK.prototype.isDevelopmentBuild = function () {
    if ($.developerMode) return true;
    return false;
  };

  GDK.prototype.mustShowSlowWin = function () {
    // have to show each line one at a time, including free spins (IT license)
    if (this.serverParser.mustShowSlowWin) {
      return this.serverParser.mustShowSlowWin();
    }
    return false;
  };

  GDK.prototype.forceGame = function (data) {
    if (this.hasForceOptions()) {
      this.serverParser.forceGame(data);
    }
  };

  GDK.prototype.onFullscreenChange = function (callback) {
    this.serverParser.onFullscreenChange(callback);
  };

  GDK.prototype.isFullscreen = function () {
    return this.serverParser.isFullscreen();
  };

  GDK.prototype.goHome = function () {
    this.serverParser.goHome();
  };

  GDK.prototype.restartIdleTimer = function () {
    this.serverParser.restartIdleTimer?.();
  };

  GDK.prototype.toggleGameIdle = function (idle) {
    this.serverParser.toggleGameIdle?.(idle);
  };

  GDK.prototype.hasHomeButton = function () {
    return this.serverParser.hasHomeButton();
  };

  GDK.prototype.getScreenWidth = function () {
    return this.serverParser.getScreenWidth();
  };

  GDK.prototype.getScreenHeight = function () {
    return this.serverParser.getScreenHeight();
  };

  GDK.prototype.getWindowSize = function () {
    return this.serverParser.getWindowSize();
  };

  GDK.prototype.getJurisdictionCode = function () {
    return this.serverParser.getJurisdictionCode?.();
  };

  GDK.prototype.getLanguageCode = function () {
    return this.serverParser.getLanguageCode?.();
  };

  GDK.prototype.getCurrencyCode = function () {
    return this.serverParser.getCurrencyCode?.();
  };

  GDK.prototype.getNumWinlines = function () {
    return this.serverParser.getNumWinlines?.();
  };
  GDK.prototype.isCheatsAllowed = function () {
    return this.serverParser.isCheatsAllowed();
  };

  GDK.prototype.onWindowResize = function (callback) {
    this.serverParser.onWindowResize(callback);
  };
  GDK.prototype.onKeydown = function (callback) {
    this.serverParser.onKeydown(callback);
  };
  GDK.prototype.onKeyup = function (callback) {
    this.serverParser.onKeyup(callback);
  };
  GDK.prototype.onFocus = function (callback) {
    this.serverParser.onFocus(callback);
  };
  GDK.prototype.onBlur = function (callback) {
    this.serverParser.onBlur(callback);
  };
  GDK.prototype.onVisibilityChange = function (callback) {
    this.serverParser.onVisibilityChange(callback);
  };
  GDK.prototype.isPageShown = function () {
    return this.serverParser.isPageShown();
  };
  GDK.prototype.requestFullscreen = function () {
    this.serverParser.requestFullscreen();
  };
  GDK.prototype.exitFullscreen = function () {
    this.serverParser.exitFullscreen();
  };
  GDK.prototype.loadingBegin = function () {
    this.serverParser.loadingBegin();
  };
  GDK.prototype.loadingComplete = function () {
    this.serverParser.loadingComplete();
  };
  GDK.prototype.loadingProgress = function (progress) {
    this.serverParser.loadingProgress(progress);
  };
  GDK.prototype.goToCashier = function () {
    this.serverParser.goToCashier();
  };
  GDK.prototype.sendFreeRoundsResponse = function (accept) {
    this.serverParser.sendFreeRoundsResponse(accept);
  };
  GDK.prototype.canStartAutoplayGame = function (callback) {
    this.serverParser.canStartAutoplayGame(callback);
  };
  GDK.prototype.loadingClosed = function () {
    game.onCloseTutorial();
    gdk.serverParser.loadingClosed();
    gdk.serverParser.clientReadyToStart(function () {
      messageBus.postImmediate('common:ReadyToStart');
    });
  };
  GDK.prototype.openHistory = function () {
    gdk.serverParser.openHistory();
  };
  GDK.prototype.startAutoplay = function () {
    gdk.serverParser.startAutoplay?.();
  };
  GDK.prototype.stopAutoplay = function () {
    gdk.serverParser.stopAutoplay?.();
  };
  GDK.prototype.toggleMuteButton = function (muted) {
    gdk.serverParser.toggleMuteButton?.(muted);
  };
  GDK.prototype.gameForces = function (json) {
    gdk.serverParser.gameForces(json);
  };
  GDK.prototype.isGameWhiteBox = function () {
    return gdk.serverParser.isGameWhiteBox();
  };
  GDK.prototype.showPlatformOverlays = function (show) {
    gdk.serverParser.showPlatformOverlays(show);
  };
  GDK.prototype.abortGame = function (reason) {
    gdk.serverParser.abortingGame(reason);
    gdk.serverParser.clearMessageQueue();
    gdk.serverParser.addBalanceEventToQueue();
    gdk.serverParser.addMessageToQueue({
      type: 'common:AbortGame',
      reason: reason,
    });

    if (gdk.serverParser.addAvailableActionsToQueue) {
      gdk.serverParser.addAvailableActionsToQueue();
    }

    gdk.serverParser.triggerNextMessage();
    messageBus.post('common:ReadyToStart');
  };

  GDK.prototype.featureStarted = function () {
    if (this.serverParser.featureStarted) {
      this.serverParser.featureStarted();
    }
  };
  GDK.prototype.featureFinished = function () {
    if (this.serverParser.featureFinished) {
      this.serverParser.featureFinished();
    }
  };

  GDK.prototype.triggerLastEvent = function () {
    this.serverParser.triggerLastEvent();
  };

  GDK.prototype.getShowMaxWinRTP = function () {
    return this.serverParser.getShowMaxWinRTP?.();
  };

  GDK.prototype.getShowMaxWinChance = function () {
    return this.serverParser.getShowMaxWinChance?.();
  };

  GDK.prototype.getShowTimer = function () {
    return this.serverParser.getShowTimer?.();
  };

  GDK.prototype.getFunMode = function () {
    return this.serverParser.getFunMode?.();
  };

  GDK.prototype.getShowNetPosition = function () {
    return this.serverParser.getShowNetPosition?.();
  };

  GDK.prototype.getUnfinishedResolution = function () {
    return this.serverParser.getUnfinishedResolution?.();
  };

  GDK.prototype.getOpenHelpOnStartup = function () {
    return this.serverParser.getOpenHelpOnStartup();
  };

  GDK.prototype.getMinBetPopup = function () {
    return this.serverParser.getMinBetPopup?.();
  };

  GDK.prototype.getHideDecline = function () {
    return this.serverParser.getHideDecline?.();
  };

  GDK.prototype.getHourlyLossLimit = function () {
    return this.serverParser.getHourlyLossLimit?.();
  };

  GDK.prototype.getSlowConnectionTimer = function () {
    return this.serverParser.getSlowConnectionTimer?.();
  };

  GDK.prototype.getPlayerOptions = function () {
    return this.serverParser.returnPlayerOptions?.();
  };

  GDK.prototype.checkMuted = function () {
    this.serverParser.checkMuted?.();
  };

  GDK.prototype.setPlayerOptions = function (data) {
    this.serverParser.setPlayerOptions?.(data);
  };

  GDK.prototype.requestAsset = function (assetName, callback) {
    var assetPath = gdk.serverParser.rootAssetPath || '';
    var filename = assetPath + assetName;
    filename = gdk.ammendResourceName(filename);

    var newRequest = new XMLHttpRequest();
    newRequest.BPG_Data = {
      retriesRemaining: 3,
    };

    newRequest.onreadystatechange = function () {
      switch (newRequest.readyState) {
        case 0:
          {
            // Unsent
          }
          break;

        case 1:
          {
            // Load called
          }
          break;

        case 2:
          {
            // Headers received
          }
          break;

        case 3:
          {
            // Downloading data
          }
          break;

        case 4:
          {
            // Load complete
            if (newRequest.status === 200) {
              //Success
              callback(assetName);
            } else if (newRequest.status === 404) {
              //File doesn't exist
              callback(assetName);
            } else {
              //Failed, retry?
              --newRequest.BPG_Data.retriesRemaining;
              if (newRequest.BPG_Data.retriesRemaining < 0) {
                console.error(filename + ' could not be loaded');
              } else {
                setTimeout(function () {
                  newRequest.open('GET', filename, true);
                  newRequest.send(null);
                }, 200);
              }
            }
          }
          break;
      }
    };

    newRequest.open('GET', filename, true);
    return newRequest;
  };

  GDK.prototype.isSocial = function () {
    return this.serverParser.isSocial?.();
  };

  gdk = new GDK();
})();
